import React, { useEffect } from 'react';
import { Card, CardContent, makeStyles, Typography } from "@material-ui/core"
import ShowMoreText from "react-show-more-text";
import { contentsActions } from "./../../actions";
import { useDispatch, useSelector } from 'react-redux';
import defaultThumb from '../../assets/imgs/Imagem_conte_C3_BAdo_fixado_web_402x.png';
import { ImagineLinkify } from "../TextLinkify";
import { SkeletonHighlightPost } from "./../../components"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(3),
    borderRadius: 8,
    border: `1px solid ${theme.palette.neutrals.high.medium}`,
    marginTop: '12px',
    cursor: 'pointer'
  },
  fixedCardContent: {
    padding: "1.5rem",
    display: "flex",
    flexDirection: "column"
  },
  fixedCardContentTitleNoLink: {
    fontWeight: "bold",
    marginBottom: "0.75rem",
  },
  fixedCardContentTitle: {
    fontWeight: "bold",
    marginBottom: "0.75rem",
  },
  fixedCardDescription: {
    fontSize: "14px",
    whiteSpace: "pre-line"
  },
  fixedCardImageWrapper: {
    height: "200px",
    width: "100%",
  },
  fixedCardImage: {
    width: "inherit",
    height: "inherit",
    objectFit: "cover",
  },
}))
export const HighlightCard = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { fixedContent, fixedLoading } = useSelector(state => state.contents)

  useEffect(() => {
    dispatch(contentsActions.getFixedContent());
  }, [dispatch]);

  return (
    <>
      {!fixedLoading && fixedContent ? (
        <Card className={classes.root} elevation={0} onClick={() => window.open(fixedContent.link, "_blank")}>
          <div className={classes.fixedCardImageWrapper}>
            <img src={fixedContent?.banner?.url ? fixedContent?.banner.url : defaultThumb} alt={fixedContent.title} className={classes.fixedCardImage} />
          </div>
          <CardContent className={classes.fixedCardContent}>
            <Typography
              variant="h6"
              color="primary"
              className={fixedContent.link ? classes.fixedCardContentTitle : classes.fixedCardContentTitleNoLink}
            >
              {fixedContent.title}
            </Typography>

            <Typography
              color="textSecondary"
              className={classes.fixedCardDescription}
            >
              <ShowMoreText
                lines={3}
                anchorClass="readMoreText"
                more="visualizar mais"
                less="visualizar menos"
                truncatedEndingComponent={"..."}
              >
                <ImagineLinkify>
                  {fixedContent.description}
                </ImagineLinkify>
              </ShowMoreText>
            </Typography>
          </CardContent>
        </Card>
      ) : (fixedLoading &&
        <SkeletonHighlightPost />
      )}
    </>
  )
}